import { initSentry } from "@eisox/tools";

// Must run before the app renders. See core/docs/architecture/observability.md.
initSentry({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_VERSION,
  tracePropagationTargets: [import.meta.env.VITE_SERVER_URL],
  // oxlint-disable-next-line typescript/no-unnecessary-type-conversion -- Vite env values are strings at runtime
  tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),
  // oxlint-disable-next-line typescript/no-unnecessary-type-conversion -- Vite env values are strings at runtime
  replaysSessionSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAY_SAMPLE_RATE),
  // oxlint-disable-next-line typescript/no-unnecessary-type-conversion -- Vite env values are strings at runtime
  replaysOnErrorSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE),
});
